import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import ModalCustom from "../../../../components/modal/ModalCustom";
import { InputValueNewClassRoom } from "../../../../domains/class-room";
import { Grid, MenuItem } from "@mui/material";
import FilterSelect from "../../../../components/select/filterSelect";
import AutocompleteSelect from "../../../../components/select/autoCompleteSelect";
import {
  ButtonOutlined,
  ButtonPrimary,
} from "../../../../components/button/ButtonCustoms";
import { EmployeeApi } from "../../../../api/employee/employee.api";
import { advisorTypeApi } from "../../../../api/advisor-type/advisor-type.api";
import { alertError } from "../../../../components/alert/swal";
import { useTranslation } from "react-i18next";

type ModalSearchAdvisorProps = {
  isOpenModal: boolean;
  setIsOpenModal: (isOpen: boolean) => void;
  inputValue: InputValueNewClassRoom;
  setInputValue: React.Dispatch<React.SetStateAction<InputValueNewClassRoom>>;
  actionType: string;
  singleAdvisor: any;
  dataAdvisor?: any[];
};

const ModalSearchAdvisor: React.FC<ModalSearchAdvisorProps> = ({
  isOpenModal,
  setIsOpenModal,
  inputValue,
  setInputValue,
  actionType,
  singleAdvisor,
  dataAdvisor
}) => {
  // console.log("actionType", actionType);
  // console.log("singleAdvisor", singleAdvisor);

  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [errorMessage, setErrorMessage] = useState<any[]>([]);
  const [dataEmployee, setDataEmployee] = useState<any[]>([]);
  const [inputSearchValue, setInputSearchValue] = useState<string>("");
  const [dataAdvisorType, setDataAdvisorType] = useState<any[]>([]);

  const [formAddAdvisor, setFormAddAdvisor] = useState<{
    advisor_id: number;
    advisor_name: string;
    advisor_type: number;
    advisor_type_name: string;
  }>({
    advisor_id: 0,
    advisor_name: "",
    advisor_type: 0,
    advisor_type_name: "",
  });

  useEffect(() => {
    if (singleAdvisor && actionType) {
      setFormAddAdvisor({
        advisor_id: singleAdvisor?.employee_id ?? 0,
        advisor_name: singleAdvisor?.employee_name ?? "",
        advisor_type: singleAdvisor?.advisor_type ?? 0,
        advisor_type_name: singleAdvisor?.advisor_type_name ?? "",
      });
    }
  }, [singleAdvisor, actionType]);

  // console.log("formAddAdvisor", formAddAdvisor);

  const handleChangeValue = (name: string, value: any) => {
    setFormAddAdvisor((prev: any) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  };

  const getDataEmployee = async () => {
    let query: any = {
      page: 1,
      limit: 1000000,
    };

    const res = await EmployeeApi.list(query);
    const data = res.data;
    if (data.status < 300) {
      setDataEmployee(data.data.items);
    } else {
      setDataEmployee([]);
    }
  };

  const getAdvisorType = async () => {
    let query: any = {
      page: 1,
      limit: 100000,
    };

    const res = await advisorTypeApi.getAllAdvisorType(query);

    const data = res.data;
    if (data.status < 300) {
      setDataAdvisorType(data.data.items);
    } else {
      setDataAdvisorType([]);
    }
  };

  useEffect(() => {
    getDataEmployee();
    getAdvisorType();
  }, []);

  const validateForm = () => {
    const errors: string[] = [];

    // Check if required fields are empty
    if (!formAddAdvisor.advisor_id) {
      errors.push("advisor_id");
    }
    if (!formAddAdvisor.advisor_type) {
      errors.push("advisor_type");
    }

    setErrorMessage(errors);

    // If there are no errors, return true
    return errors.length === 0;
  };

  const handlePushDataAdvistor = (
    advisor_id: number,
    advisor_name: string,
    advisor_type_id: number,
    advisor_type: string
  ) => {
    if (validateForm()) {
      setInputValue((prevInputValue) => {
        // Check if advisor already exists based on advisor_id
        const existingAdvisorIndex = prevInputValue.advisor.findIndex(
          (advisor) => advisor.employee_id === advisor_id
        );

        // If advisor already exists, return the previous state to prevent duplicate entries
        if (existingAdvisorIndex !== -1) {
          setErrorMessage(["advisor_id"]);
          return prevInputValue;
        }

        setIsOpenModal(false);
        setErrorMessage([]);
        // If advisor does not exist, add a new advisor entry
        return {
          ...prevInputValue,
          advisor: [
            ...prevInputValue.advisor,
            {
              employee_id: advisor_id,
              employee_name: advisor_name,
              advisor_type: advisor_type_id,
              advisor_type_name: advisor_type,
            },
          ],
        };
      });
    }
  };

  // Function to update an existing advisor's information by advisor_id
  const handleUpdateDataAdvistor = (
    advisor_id: number,
    advisor_name: string,
    advisor_type_id: number,
    advisor_type: string
  ) => {
    if (advisor_id && advisor_type_id) {
      setInputValue((prevInputValue) => {
        const updatedAdvisors = prevInputValue.advisor.map((advisor) =>
          advisor.employee_id === advisor_id
            ? {
              ...advisor,
              employee_name: advisor_name,
              advisor_type: advisor_type_id,
              advisor_type_name: advisor_type,
            }
            : advisor
        );

        return {
          ...prevInputValue,
          advisor: updatedAdvisors,
        };
      });
      handleCloseModal();
    } else {
      setIsOpenModal(false);
      setErrorMessage(["advisor_id", "advisor_type"]);
    }
  };

  const handleCloseModal = () => {
    setIsOpenModal(false);
    setFormAddAdvisor({
      advisor_id: 0,
      advisor_name: "",
      advisor_type: 0,
      advisor_type_name: "",
    })
  }

  const advisor_type_data = [
    { label: t('อาจารย์ผู้สอนหลัก'), value: 'อาจารย์ผู้สอนหลัก' }, // i18n-ignore
    { label: t('อาจารย์ผู้สอนร่วม'), value: 'อาจารย์ผู้สอนร่วม' }] // i18n-ignore

    // console.log(dataAdvisor,'dataAdvisor')
  return (
    <ModalCustom
      title={t("เพิ่มอาจารย์ที่ปรึกษา")}
      subTitle={t("กรุณาระบุข้อมูลให้ครบถ้วนก่อนการยืนยัน")}
      open={isOpenModal}

      onClose={handleCloseModal}
      component={
        <Grid container spacing={2}>
          <Grid
            item
            lg={12}
            md={12}
            sm={12}
            xs={12}
            sx={{
              alignSelf: "end",
            }}
          >
            <AutocompleteSelect
              heading={t("ชื่อ-นามสกุล อาจารย์")}
              helperText={
                errorMessage.includes("advisor_id")
                  ? "Advisor ID is required."
                  : ""
              }
              required
              freeSolo
              labelId={"-"}
              options={dataEmployee?.filter((x) => !dataAdvisor?.map((x) => x?.employee_id)?.includes(x?.id_employee)) ?? []}
              value={
                dataEmployee.find(
                  (x: any) => x?.id_employee === formAddAdvisor.advisor_id
                ) || null
              }
              getOptionLabel={(option: any) => `${option?.fullname}` || ""}
              renderOption={(props, option) => (
                <li {...props}>{`${option?.fullname}`}</li>
              )}
              onChange={(_, value: any) => {
                if (value) {
                  setInputSearchValue(value?.id_employee);
                  handleChangeValue("advisor_id", value.id_employee);
                  handleChangeValue("advisor_name", value.fullname);
                } else {
                  setInputSearchValue("");
                }
              }}
              disabled={actionType === "view" || actionType === "update"}
            />
          </Grid>

          <Grid
            item
            lg={12}
            md={12}
            sm={12}
            xs={12}
            sx={{
              alignSelf: "end",
            }}
          >
            <FilterSelect
              helperText={
                errorMessage.includes("advisor_type")
                  ? "Advisor Type ID is required."
                  : ""
              }
              required
              heading={t("ประเภท")}
              value={formAddAdvisor.advisor_type_name ?? ""}
              onchange={(e: React.ChangeEvent<{ value: unknown }>) => {
                // const is_duplicate_employee = dataAdvisor?.some((x) => 'อาจารย์ผู้สอนหลัก' == e.target.value);
                // if (is_duplicate_employee) {
                //   return alertError("อาจารย์ผู้สอนหลักมีได้แค่ 1 คนเท่านั้น")
                // }
                // const selectedOption = dataAdvisorType.find(
                //   (item) => item.id_advisor_type === e.target.value
                // );
                // if (selectedOption) {
                handleChangeValue(
                  "advisor_type",
                  e.target.value
                );
                handleChangeValue(
                  "advisor_type_name",
                  e.target.value
                );
                // }
              }}
              // options={[
              //   {
              //     value: 0,
              //     label: "เลือกประเภท",
              //   },
              //   ...dataAdvisorType.map((item, index) => ({
              //     value: item.id_advisor_type, // Ensure year is a string
              //     label: item.advisor_type_name,
              //   })),
              // ].map((option: any) => (
              //   <MenuItem value={option.value} key={option.value}>
              //     {option.label}
              //   </MenuItem>
              // ))}
              options={advisor_type_data?.map((list) => (
                <MenuItem value={list.value} key={list.value}>
                  {list.label || ""}
                </MenuItem>
              ))}
              labelId={"xx"}
              selectId={"xxxx"}
              disabled={actionType === "view"}
            />
          </Grid>

          <Grid
            item
            lg={12}
            md={12}
            sm={12}
            xs={12}
            sx={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <ButtonOutlined
              onClick={() => {
                setIsOpenModal(false);
              }}
              mode="del"
              buttonName={t("ยกเลิก")}
              btnProps={{
                width: "125px",
                margin: "12px",
              }}
            />
            {actionType === "create" && (
              <ButtonPrimary
                onClick={() => {
                  handlePushDataAdvistor(
                    formAddAdvisor.advisor_id,
                    formAddAdvisor.advisor_name,
                    formAddAdvisor.advisor_type,
                    formAddAdvisor.advisor_type_name
                  );
                }}
                mode="success"
                buttonName={t("ยืนยัน")}
                disabled={!formAddAdvisor.advisor_type}
                btnProps={{
                  width: "125px",
                  margin: "12px",
                }}
              />
            )}

            {actionType === "update" && (
              <ButtonPrimary
                onClick={() => {
                  handleUpdateDataAdvistor(
                    formAddAdvisor.advisor_id,
                    formAddAdvisor.advisor_name,
                    formAddAdvisor.advisor_type,
                    formAddAdvisor.advisor_type_name
                  );
                  // setIsOpenModal(false);
                }}
                mode="success"
                buttonName={t("ยืนยัน")}
                disabled={!formAddAdvisor.advisor_type}
                btnProps={{
                  width: "125px",
                  margin: "12px",
                }}
              />
            )}
          </Grid>
        </Grid>
      }
    />
  );
};

export default ModalSearchAdvisor;
